import { render, staticRenderFns } from "./TermsList.vue?vue&type=template&id=316f66ab&scoped=true"
import script from "./TermsList.vue?vue&type=script&lang=ts"
export * from "./TermsList.vue?vue&type=script&lang=ts"
import style0 from "./TermsList.vue?vue&type=style&index=0&id=316f66ab&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "316f66ab",
  null
  
)

export default component.exports